/**
 * 全局配置文件, 定义初始化参数
 */
export default {
  title: "SRM",
  logo: "BOE",
  // logoImg: "/img/qqtlogo.png",
  indexTitle: "BOE SRM",
  lockPage: "/lock",
  tokenTime: 60 * 60 * 22,
  info: {
    title: "",
    list: [""],
  },
  // http的status默认放行不采用统一处理的,
  statusWhiteList: [400, 201],
  staticPath: "/static/",
  staticConfigPath: "/static/config/",
  // 配置首页不可关闭
  isFirstPage: false,
  firstPage: {
    label: "首页",
    value: "/vendor/#/wel",
    params: {},
    query: {},
    group: [],
    close: false,
  },
  // 配置菜单的属性
  menu: {
    domain: "http://boe.51qqt.com",
    uatdomain: "https://boe.51qqt.com/",
    props: {
      label: "appName",
      path: "appUrl",
      icon: "appIcon",
      children: "children",
    },
  },
};
